import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Notification from "components/Common/Notification";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { createPartyApi, baseUrl, updatePartyApi } from "api";
import { isValid } from "redux-form";
import { withTranslation } from "react-i18next";

class AddParty extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      validation: "",
      firstSubmit: false,
      showNotification: false,
      notificationMessage: "",
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: false, isView: false, data: null },
      selectedFiles: [],
    };

    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
  }
  componentDidMount() {
    if (
      this.state?.props?.data?.logo &&
      this.state?.props?.data?.logo != "null"
    ) {
      this.setState({
        selectedFiles: [
          {
            preview: `${baseUrl}/uploads/${this.state.props.data.logo}`,
          },
        ],
      });
    }
  }
  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == false) {
      let formdata = new FormData();
      delete values.id;
      Object.keys(values).forEach(x => formdata.append(x, values[x]));
      if (this.state.selectedFiles.length)
        formdata.append("logo", this.state.selectedFiles[0]);
      const data = await createPartyApi(formdata);
    } else {
      let formdata = new FormData();
      Object.keys(values).forEach(x => formdata.append(x, values[x]));
      if (this.state.selectedFiles.length) {
        formdata.delete("logo");
        if ("formattedSize" in this.state.selectedFiles[0])
          formdata.append("logo", this.state.selectedFiles[0]);
      }
      if (formdata.get("logo") == "null") formdata.delete("logo");
      const data = await updatePartyApi({
        id: formdata.get("id"),
        data: formdata,
      });
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  render() {
    //meta title
    document.title =
      this.state.props.isEdit == false ? "Add Party" : "Edit Party";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Alert isOpen={this.state.showNotification}>
            {this.state.notificationMessage}
          </Alert>
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Manage Party")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.props.data == null
                          ? {
                              contactPersonName: "",
                              name: "",
                              partyCode: "",
                              gstNo: "",
                              panNo: "",
                              cinLlpIn: "",
                              tdsRate: "",
                              addressLine1: "",
                              addressLine2: "",
                              city: "",
                              state: "",
                              zipCode: "",
                              cvdRate: "",
                              lphtRate: "",
                              realRate: "",
                              jiramRate: "",
                              mobileNo1: "",
                              mobileNo2: "",
                              email: "",
                              shortName: "",
                              since: "",
                              tagLine: "",
                              adminNotes: "",
                              status: true,
                            }
                          : this.state.props.data
                      }
                      validationSchema={Yup.object().shape({
                        logo: Yup.string()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value => !value || (value && value.size <= 500000)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value &&
                                ["jpg", "jpeg", "png"].includes(value.type))
                          ),
                        contactPersonName: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Contact person Name"),
                        partyCode: Yup.string().required(
                          "Please Enter Your Party Code"
                        ),
                        name: Yup.string()
                          .min(1)
                          .max(255)
                          .required(
                            "Please Enter Your {this.props.t('Party Name')}"
                          ),
                        gstNo: Yup.string()
                          .min(0)
                          .max(255)
                          .required("Please Enter Your GST number"),
                        panNo: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your PAN number"),
                        cinLlpIn: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your CIN/LLP number"),
                        tdsRate: Yup.number()
                          .min(1)
                          .max(32767)
                          .required("Please Enter Your tds rate"),
                        addressLine1: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your Address"),
                        addressLine2: Yup.string()
                          .min(1)
                          .max(255)
                          .nullable()
                          .notRequired(),
                        city: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your city"),
                        state: Yup.string()
                          .min(1)
                          .max(32767)
                          .required("Please Enter Your state"),
                        zipCode: Yup.number()
                          .min(1)
                          .max(999999)
                          .nullable()
                          .notRequired(),
                        cvdRate: Yup.number()
                          .min(1)
                          .max(32767)
                          .required("Please Enter CVD Rate"),
                        lphtRate: Yup.number()
                          .min(1)
                          .max(32767)
                          .required("Please Enter LPHT rate"),
                        realRate: Yup.number()
                          .min(1)
                          .max(32767)
                          .required("Please Enter REAL rate"),
                        jiramRate: Yup.number()
                          .min(1)
                          .max(32767)
                          .required("Please Enter JIRAM rate"),
                        mobileNo1: Yup.number()
                          .min(1111111111)
                          .max(9999999999)
                          .required("Please Enter Your Mobile Number"),
                        mobileNo2: Yup.number()
                          .min(1111111111)
                          .max(9999999999)
                          .nullable()
                          .notRequired(),
                        email: Yup.string()
                          .min(1)
                          .max(50)
                          .required("Please Enter Your email"),
                        shortName: Yup.string()
                          .min(1)
                          .max(10)
                          .required("Please Enter Your Short Name"),
                        since: Yup.number()
                          .min(1111)
                          .max(9999)
                          .required("This value is required"),
                        tagLine: Yup.string()
                          .min(1)
                          .max(255)
                          .required("This value is required"),
                        adminNotes: Yup.string()
                          .min(1)
                          .max(255)
                          .required("This value is required"),
                      })}
                    >
                      {({
                        errors,
                        status,
                        touched,
                        values,
                        isValid,
                        submitCount,
                        validateForm,
                      }) => (
                        <Form className="needs-validation">
                          <h4 className="pb-3 text-black fw-bold">
                            {this.state.props.isEdit == false ? (
                              <div> {this.props.t("Add Party")}</div>
                            ) : (
                              <div className="d-flex flex-row mb-4 justify-content-between">
                                <div>
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.state.props.isView
                                      ? " view Party Details"
                                      : "Edit Party Details"}
                                  </h4>
                                </div>
                                <div>
                                  <div className="d-inline-block me-3 fs-5 fw-bold">
                                    Active
                                  </div>
                                  <div className="form-check form-switch d-inline-block">
                                    <Field
                                      className="form-check-input fs-5"
                                      type="checkbox"
                                      name="status"
                                      disabled={
                                        this.state.props.isView ? true : false
                                      }
                                    />
                                    <label className="form-check-label pt-4"></label>
                                  </div>
                                </div>
                              </div>
                            )}
                          </h4>
                          <Row>
                            <div className="mb-3 row">
                              {this.state.props.isView ? (
                                this.state?.props?.data?.logo != null ? (
                                  <>
                                    <label
                                      htmlFor="example-number-input"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Logo")}
                                      </h5>
                                    </label>
                                    <div className="col-md-10">
                                      <div
                                        className="dropzone-previews mt-3"
                                        id="file-previews"
                                      >
                                        {this.state.selectedFiles.map(
                                          (f, i) => {
                                            return (
                                              <Card
                                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                key={i + "-file"}
                                              >
                                                <div className="p-2">
                                                  <Row className="align-items-center">
                                                    <Col className="col-auto">
                                                      <img
                                                        data-dz-thumbnail=""
                                                        height="80"
                                                        className="avatar-sm rounded bg-light"
                                                        alt={f.name}
                                                        src={f.preview}
                                                      />
                                                    </Col>
                                                    <Col>
                                                      <Link
                                                        to="#"
                                                        className="text-muted font-weight-bold"
                                                      >
                                                        {f.name}
                                                      </Link>
                                                      <p className="mb-0">
                                                        <strong>
                                                          {f.formattedSize}
                                                        </strong>
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Card>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )
                              ) : (
                                <>
                                  <label
                                    htmlFor="example-number-input"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("Party Logo")}
                                    </h5>
                                  </label>
                                  <div className="col-md-10">
                                    <Dropzone
                                      multiple={false}
                                      disabled={this.state.props.isView}
                                      onDrop={acceptedFiles => {
                                        this.handleAcceptedFiles(acceptedFiles);
                                      }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="mb-3">
                                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h4>
                                              Drop logo here or click to upload.
                                            </h4>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                    {/* {this.state.selectedFiles.length < 1 &&
                                  submitCount > 0 ? (
                                    <p className="text-danger">
                                      Please Upload Photo
                                    </p>
                                  ) : (
                                    <></>
                                  )} */}
                                    <div
                                      className="dropzone-previews mt-3"
                                      id="file-previews"
                                    >
                                      {this.state.selectedFiles.map((f, i) => {
                                        return (
                                          <Card
                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                            key={i + "-file"}
                                          >
                                            <div className="p-2">
                                              <Row className="align-items-center">
                                                <Col className="col-auto thumb">
                                                  <img
                                                    data-dz-thumbnail=""
                                                    height="80"
                                                    className="avatar-sm rounded bg-light thumbInner"
                                                    alt={f.name}
                                                    src={f.preview}
                                                  />
                                                  <button
                                                    type="button"
                                                    onClick={() => {
                                                      this.setState(
                                                        this.state.selectedFiles.pop()
                                                      );

                                                      this.setState([
                                                        ...this.state
                                                          .selectedFiles,
                                                      ]);
                                                    }}
                                                    className="bg-transparent border-0"
                                                  >
                                                    {" "}
                                                    <div className="middle">
                                                      <i className="fa-solid fa-circle-xmark fs-1 bg-white text-secondary"></i>
                                                    </div>
                                                  </button>
                                                </Col>
                                                <Col>
                                                  <Link
                                                    to="#"
                                                    className="text-muted font-weight-bold"
                                                  >
                                                    {f.name}
                                                  </Link>
                                                  <p className="mb-0">
                                                    <strong>
                                                      {f.formattedSize}
                                                    </strong>
                                                  </p>
                                                </Col>
                                              </Row>
                                            </div>
                                          </Card>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="contactPersonName"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Contact Person")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                {}
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.contactPersonName &&
                                    touched.contactPersonName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="contactPersonName"
                                  placeholder="contact person"
                                />
                                <ErrorMessage
                                  name="contactPersonName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="partyCode"
                                  placeholder="xxx0125fgtr"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Party Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                  disabled={this.state.props.isView}
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="gstNo"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("GST No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.gstNo && touched.gstNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="gstNo"
                                  placeholder="04AABCU9603R1ZV"
                                  disabled={this.state.props.isView}
                                />
                                <ErrorMessage
                                  name="gstNo"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="panNo"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Pan No.")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.panNo && touched.panNo
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="panNo"
                                  disabled={this.state.props.isView}
                                  placeholder="AAECC6548C"
                                />
                                <ErrorMessage
                                  name="panNo"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cinLlpIn"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  CIN / LLP IN
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cinLlpIn && touched.cinLlpIn
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="cinLlpIn"
                                  disabled={this.state.props.isView}
                                  placeholder="L01631KA2010PTC096843"
                                />
                                <ErrorMessage
                                  name="cinLlpIn"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="tdsRate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("TDS Rate")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.tdsRate && touched.tdsRate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="tdsRate"
                                  disabled={this.state.props.isView}
                                  placeholder="tds Rate"
                                />
                                <ErrorMessage
                                  name="tdsRate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine1 && touched.addressLine1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  disabled={this.state.props.isView}
                                  name="addressLine1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine2 && touched.addressLine2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  disabled={this.state.props.isView}
                                  name="addressLine2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("City")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="city"
                                  disabled={this.state.props.isView}
                                  placeholder="City"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("State")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    this.state.props.isView
                                      ? "form-control fs-5" +
                                        (errors.state && touched.state
                                          ? " is-invalid"
                                          : "")
                                      : "form-control form-select fs-5" +
                                        (errors.state && touched.state
                                          ? " is-invalid"
                                          : "")
                                  }
                                  name="state"
                                  as="select"
                                  disabled={this.state.props.isView}
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="1">Gujarat</option>
                                  <option value="2">Maharashtra</option>
                                  <option value="3">Tamil Nadu</option>
                                  <option value="4">Uttar Pradesh</option>
                                  <option value="5">West Bengal</option>
                                  <option value="6">Karnataka</option>
                                  <option value="7">Rajasthan</option>
                                  <option value="8">Andhra Pradesh</option>
                                  <option value="9">Madhya Pradesh</option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <div className="col-md-6 col-12">
                                <div className="row">
                                  <div className="col-md-4">
                                    <Label
                                      htmlFor="zipCode"
                                      className="col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Zip Code")}
                                      </h5>
                                    </Label>
                                  </div>
                                  <div className="col-md-8">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.zipCode && touched.zipCode
                                          ? " is-invalid"
                                          : "")
                                      }
                                      disabled={this.state.props.isView}
                                      type="text"
                                      name="zipCode"
                                      placeholder="zip code"
                                    />
                                    <ErrorMessage
                                      name="zipCode"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 col-12">
                                <div className="row">
                                  <div className="col-md-4 text-start text-lg-center">
                                    <Label
                                      htmlFor="duplicateRate"
                                      className="col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Duplicate Rate")}
                                      </h5>
                                    </Label>
                                  </div>
                                  <div className="col-md-8">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.duplicateRate &&
                                        touched.duplicateRate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="number" onWheel={(e) => e.target.blur()}
                                      disabled={this.state.props.isView}
                                      name="duplicateRate"
                                      placeholder="Different Rate"
                                    />
                                    <ErrorMessage
                                      name="duplicateRate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <div className="col-md-6 col-12">
                                <div className="row">
                                  <div className="col-md-4">
                                    <Label
                                      htmlFor="cvdRate"
                                      className="col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("CVD Rate")}
                                      </h5>
                                    </Label>
                                  </div>
                                  <div className="col-md-8">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.cvdRate && touched.cvdRate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      disabled={this.state.props.isView}
                                      type="number" onWheel={(e) => e.target.blur()}
                                      name="cvdRate"
                                      placeholder="Different Rate"
                                    />
                                    <ErrorMessage
                                      name="cvdRate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 col-12">
                                <div className="row">
                                  <div className="col-md-4 text-start text-lg-center">
                                    <Label
                                      htmlFor="lphtRate"
                                      className="col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("LPHT Rate")}
                                      </h5>
                                    </Label>
                                  </div>
                                  <div className="col-md-8">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.lphtRate && touched.lphtRate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="number" onWheel={(e) => e.target.blur()}
                                      disabled={this.state.props.isView}
                                      name="lphtRate"
                                      placeholder="Different Rate"
                                    />
                                    <ErrorMessage
                                      name="lphtRate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <div className="col-md-6 col-12">
                                <div className="row">
                                  <div className="col-md-4">
                                    <Label
                                      htmlFor="realRate"
                                      className="col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("REAL Rate")}
                                      </h5>
                                    </Label>
                                  </div>
                                  <div className="col-md-8">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.realRate && touched.realRate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="number" onWheel={(e) => e.target.blur()}
                                      disabled={this.state.props.isView}
                                      name="realRate"
                                      placeholder="Different Rate"
                                    />
                                    <ErrorMessage
                                      name="realRate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6 col-12">
                                <div className="row">
                                  <div className="col-md-4 text-start text-lg-center">
                                    <Label
                                      htmlFor="jiramRate"
                                      className="col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("JIRAM Rate")}
                                      </h5>
                                    </Label>
                                  </div>
                                  <div className="col-md-8">
                                    <Field
                                      className={
                                        "form-control fs-5" +
                                        (errors.jiramRate && touched.jiramRate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      type="number" onWheel={(e) => e.target.blur()}
                                      disabled={this.state.props.isView}
                                      name="jiramRate"
                                      placeholder="Different Rate"
                                    />
                                    <ErrorMessage
                                      name="jiramRate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo1 && touched.mobileNo1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo1"
                                  disabled={this.state.props.isView}
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo2 && touched.mobileNo2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  disabled={this.state.props.isView}
                                  name="mobileNo2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Email ID")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="email"
                                  disabled={this.state.props.isView}
                                  name="email"
                                  placeholder="Enter a valid Email ID"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="shortName"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Short Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.shortName && touched.shortName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="shortName"
                                  placeholder="P3Y"
                                />
                                <ErrorMessage
                                  name="shortName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="since"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Since")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.since && touched.since
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="since"
                                  placeholder="2001"
                                />
                                <ErrorMessage
                                  name="since"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="tagLine"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Tagline")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.tagLine && touched.tagLine
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="tagLine"
                                  placeholder="#tagLine"
                                />
                                <ErrorMessage
                                  name="tagLine"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="adminNotes"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Admin Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.adminNotes && touched.adminNotes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  disabled={this.state.props.isView}
                                  name="adminNotes"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="adminNotes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-lg-end text-center">
                              {this.state.props.isView ? (
                                <Link to="/party-list">
                                  <Button color="primary" className="fs-4 px-5">
                                    Back
                                  </Button>
                                </Link>
                              ) : (
                                <Button
                                  color="primary"
                                  className="fs-4 px-5"
                                  type="submit"
                                  onClick={() => {
                                    if (this.state.props.isEdit == false) {
                                      validateForm()
                                        .then(data => {
                                          if (Object.keys(data).length == 0) {
                                            this.handleSubmit(event, values);
                                          }
                                        })
                                        .catch(err => console.log(err));
                                    } else {
                                      this.handleSubmit(event, values);
                                    }
                                  }}
                                >
                                  {this.state.props.isEdit == false ? "Submit" : "Update"} 
                                </Button>
                              )}
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(AddParty);
